<template>
  <div>
    <p v-html="formattedString" />
    <span v-show="text.length > maxChars">
      <div
        v-show="!isReadMore"
        @click="triggerReadMore($event, true)"
      >
        <slot name="readMore" />
      </div>
      <div
        v-show="isReadMore"
        @click="triggerReadMore($event, false)"
      >
        <slot name="readLess" />
      </div>
    </span>
  </div>
</template>

<script>
export default {
  name: 'ReadMoreToggler',
  props: {
    text: {
      type: String,
      required: true
    },
    maxChars: {
      type: Number,
      default: 100
    }
  },

  data () {
    return {
      isReadMore: false
    }
  },

  computed: {
    formattedString () {
      let valContainer = this.text

      if (!this.isReadMore && this.text.length > this.maxChars) {
        valContainer = valContainer.substring(0, this.maxChars) + '...'
      }

      return valContainer
    }
  },

  methods: {
    triggerReadMore (event, value) {
      this.isReadMore = value
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ReadMoreToggler.vue